import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { PlayersCurrentTeamData, StorageUtil } from '../../../store';
import { MyProfileDashboardService, HelperService } from '../../../services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-current-teams',
  templateUrl: './current-teams.component.html',
  styleUrls: ['./current-teams.component.css']
})
export class CurrentTeamsComponent implements OnInit {

  @Input() playerID;
  teamID;
  teamList: PlayersCurrentTeamData;
  isOpenConfirmDeletePopup = false;

  constructor(
    private fb: FormBuilder,
    private dashboardService: MyProfileDashboardService,
    private tgsloaderService: Ng4LoadingSpinnerService,
    private helperService: HelperService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.getPlayersCurrentTeamData();
  }

  setLogo(url) {
    return this.helperService.setClubLogo(url);
  }

  getPlayersCurrentTeamData() {
    const getDashboardData = this.dashboardService.getPlayersCurrentTeamData(this.playerID, StorageUtil.clubID).subscribe((rs: any) => {
      this.tgsloaderService.hide();
      this.teamList = rs.data;
      getDashboardData.unsubscribe();
    });
  }

  deleteMeFromSelectedTeam(teamID, event) {
    this.teamID = teamID;
    this.openPopup();
  }

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
  }

  closePopup() {
    this.isOpenConfirmDeletePopup = false;
  }

  alertMessage(status, message) {
    if (status === 'error') {
      const toast = this.notificationsService.error('HEADS UP!', message, {
        timeOut: 5000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    }
  }

  refreshReocrds() {
    this.getPlayersCurrentTeamData();
  }

  confirmRemove(confirm) {
    if (confirm) {
      this.removeTeam();
    }
  }

  removeTeam() {
    this.tgsloaderService.show();
    this.dashboardService.removePlayerFromTeam(this.playerID, this.teamID).subscribe((rs: any) => {
      this.tgsloaderService.hide();
      this.helperService.alertMessage('success', 'Success', 'Player removed from Team Successfully.');
      this.closePopup();
      this.refreshReocrds();
    }, error => {
      console.log(error);
      this.alertMessage('error', error.error);
      this.closePopup();
      this.tgsloaderService.hide();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/current-teams/current-teams.component.ts